<div class="corte-dialog">
  <header class="corte-dialog__header corte-dialog__header--confirm">
    <div class="corte-dialog__icon corte-dialog__icon--confirm" aria-hidden="true">
      <i-tabler name="circle-check"></i-tabler>
    </div>
    <div>
      <h2>Confirmar OS</h2>
      <p *ngIf="data.orderLabel">OS {{ data.orderLabel }}</p>
    </div>
  </header>

  <div class="corte-dialog__body">
    <p>Pasa a confirmada, congela el costo y genera el PDF.</p>
    <p class="corte-dialog__error" *ngIf="error">{{ error }}</p>
  </div>

  <footer class="corte-dialog__actions">
    <button type="button" class="corte-dialog__ghost" (click)="close()" [disabled]="saving">
      Cancelar
    </button>
    <button
      type="button"
      class="corte-dialog__primary corte-dialog__primary--confirm"
      (click)="confirm()"
      [disabled]="saving"
    >
      {{ saving ? 'Confirmando…' : 'Confirmar' }}
    </button>
  </footer>
</div>
